import React, { useState } from "react";
import style from "./userCard.module.scss";
import SwitchButton from '../../SelectionControls/Switch/Switch'
import Dropdown from "../../Dropdown/ThreeDotsDropDown/DropDown"
import Toggle from "../../channels/rectangleToggle/rectangleToggle"
import ToPersianNumber from "../../../helpers/actions/toPersianNumber"

const UsersCard = (props) => {
    const [dropdown, setDropdown] = useState(false)
    return (
        <div className={style.container}>
            <div className={style.dropdownContainer}>
                <Dropdown
                    tag={props.data.name}
                    items={[
                        {
                            name: 'حذف', onclick: () => props.dropdown("delete", props.data._id), modalOpen: () => {
                                setDropdown(false)
                            }, editable: props.data.editable, disable: !props.data.editable
                        }
                    ]}
                />
            </div>
            <div className={style.name}>{props.data.name}</div>
            <div className={style.toggleWrapper}>
                <SwitchButton
                    value={props.data.active}
                    tag={'isUserActive'}
                    disabled={!props.data.editable}
                    onclick={(id, active) => props.toggleHandlerParent(id, active)}
                />
            </div>
            <div className={style.dateWrapper}>{ToPersianNumber((props.data.phone))}</div>
            <div className={style.accessWrapper}>{typeof props.data.permission !== "undefined" ? props.data.permission.title : "____"}</div>
            <div className={style.buttonWrapper}>
                <button
                    className={style.editButton}
                    disabled={!props.data.editable}
                    onClick={() => () => props.dropdown("edit", props.data._id)}
                >
                    <div className={style.icon}></div>
                    ویرایش
                </button>
            </div>
        </div>
    )
}
export default UsersCard;
